import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ImageMasterResponse } from './imagemaster.interface';
import { ImageMaster_ExternalUpload, ImageMaster_Upload } from 'src/app/GlobalVariable';

@Injectable({
  providedIn: 'root'
})
export class ImageMasterService {

  constructor() { }

  http = inject(HttpClient);

  ImageMaster_Upload(file: File): Observable<ImageMasterResponse> {
    const formData = new FormData();  
    formData.append('File', file, file.name);
    formData.append('CompanyId', '0');
    formData.append('BranchId', '0');
    formData.append('SoftwareId', '0');

    return this.http.post<ImageMasterResponse>(ImageMaster_Upload, formData);
  }

  ImageMaster_ExternalUpload(file: File): Observable<ImageMasterResponse> {
    const formData = new FormData();  
    formData.append('File', file, file.name);
    formData.append('CompanyId', '0');
    formData.append('BranchId', '0');
    formData.append('SoftwareId', '0');

    return this.http.post<ImageMasterResponse>(ImageMaster_ExternalUpload, formData);
  }
}
